/**
 * Подпись чата для показа.
 *
 * Отдельная функция, а не `chat.title ?? 'Без названия'` по месту.
 *
 * Оператор `??` подставляет запасное значение только для null и undefined, а
 * Telegram отдаёт и ПУСТУЮ строку — у удалённых аккаунтов, у некоторых
 * служебных чатов. Пустая строка сквозь `??` проходит как есть, и строка
 * списка теряет название целиком: остаются метка аккаунта и время, а понять,
 * что это за переписка, нельзя.
 *
 * Тот же случай был во всех четырёх местах, где подпись собиралась вручную.
 */
export function chatTitle(title: string | null | undefined): string {
  const trimmed = title?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : 'Без названия';
}
